import React from 'react';

/**
 * Decorative section divider for category groups.
 * Shows a thick green bar + title + soft trailing line.
 */
const CategorySectionHeader = ({ title, count }) => {
  return (
    <div className="mb-6 mt-2">
      <div className="flex items-center gap-4">
        <div className="h-2.5 w-16 rounded-full bg-emerald-600" />
        <h2 className="text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">{title}</h2>
        {typeof count === 'number' && (
          <span className="shrink-0 rounded-full bg-emerald-50 px-3 py-1 text-xs font-semibold text-emerald-800">
            {count}
          </span>
        )}
        <div className="h-1 flex-1 rounded-full bg-gradient-to-r from-emerald-200 via-emerald-100 to-transparent" />
      </div>
    </div>
  );
};

export default CategorySectionHeader;
